import * as React from "react";
import { SVGProps, memo } from "react";

const SvgInformationGreen = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={25} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.875 12.5a7.875 7.875 0 1 1-15.75 0 7.875 7.875 0 0 1 15.75 0Zm1.875 0c0 5.385-4.365 9.75-9.75 9.75s-9.75-4.365-9.75-9.75S6.615 2.75 12 2.75s9.75 4.365 9.75 9.75Zm-8.625-4.125a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0ZM12 10.813c.518 0 .938.42.938.937v4.875a.937.937 0 1 1-1.876 0V11.75c0-.518.42-.938.938-.938Z"
      fill="#2BA168"
    />
  </svg>
);

const Memo = memo(SvgInformationGreen);

export default Memo;
